module.exports = __webpack_public_path__ + "static/img/68081E_6_R_20200731_fit.401650a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081E_6_R_20200731_fit.png
// module id = ZVYo
// module chunks = 0